import { Bars, Shops, Sights } from '@lt/components/icons-react/map';
import { i18n } from '@lt/localization';

export const accessToken =
  'pk.eyJ1IjoiZXRvbHN0b3YiLCJhIjoiY2pnNmR2YmY5MDl5ODMzb2UzdXFiMmk3YiJ9.RpRjvAAhh5D-JRrN0YvRwg';
export const tilesUrl = 'https://tiles.yc.level.travel/custom/map-v1.json';

/**
 * Новые тайлы, август 2022
 * Содержат слои hotels, для стилизации точек отелей на карте
 * @see https://w.level.travel/ru/%D0%9F%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%9A%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82%D1%8B_%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82%D0%B0/%D0%A1%D0%B0%D0%B9%D1%82/%D0%9A%D0%B0%D1%80%D1%82%D0%B0
 */
export const tilesUrlv2 = 'https://tiles.yc.level.travel/custom/map-v2.json';

export const isWebGlSupported = () => {
  try {
    const canvas = document.createElement('canvas');
    return Boolean(
      canvas.getContext('webgl') || canvas.getContext('experimental-webgl'),
    );
  } catch (error) {
    return false;
  }
};

const borderRadius = '48px';

export const HEATMAP_LAYERS = [
  {
    id: 'hm_food_and_drinks',
    name: i18n.t('map.utils.cafe'),
    icon: Bars,
    activeBgColor: '#FFC20D',
    borderRadius: `
      border-top-left-radius: ${borderRadius};
      border-top-right-radius: ${borderRadius};
    `,
  },
  {
    id: 'hm_tourism',
    name: i18n.t('map.utils.place'),
    icon: Sights,
    activeBgColor: '#2B54A7',
  },
  {
    id: 'hm_shopping',
    name: i18n.t('map.utils.shopping'),
    icon: Shops,
    activeBgColor: '#25D97F',
    borderRadius: `
      border-bottom-right-radius: ${borderRadius};
      border-bottom-left-radius: ${borderRadius};
    `,
  },
];
